module.exports = __webpack_public_path__ + "teqbahn-assets/media/6.5ec71e4a.png";